import axios from 'axios'

export const getAllShipment = (params) => {
  let remoteUrl = 'shipments'

  return axios.get(remoteUrl, {params: params})
}

export const getShipment = (id, params) => {
  let remoteUrl = 'shipments/' + id
  return axios.get(remoteUrl, {params: params})
}

export const exportExcel = (params) => {
  return axios.get('shipments/export-excel', {params: params})
}

export const getFeeList = (shipment) => {
  var remoteUrl = 'fees-list'
  return axios.post(remoteUrl, shipment)
}

export const getCoinFeeList = (shipment) => {
  var remoteUrl = 'fees-list-by-carrier'
  return axios.post(remoteUrl, shipment)
}

export const addShipment = (shipment) => {
  var remoteUrl = 'shipments'
  return axios.post(remoteUrl, shipment)
}

export const deleteShipment = (id) => {
  let remoteUrl = 'shipments/' + id
  return axios.delete(remoteUrl)
}

export const updatePriceShipment = (id, shipment) => {
  var remoteUrl = 'shipments/' + id + '/update-price'
  return axios.put(remoteUrl, shipment).then(response => {
    return response.json()
  }, errors => {
    return errors.json()
  })
}

export const editShipment = (id, shipment, params) => {
  var remoteUrl = 'shipments/' + id
  return axios.put(remoteUrl, shipment, {params: params})
}

export const getFilter = (params) => {
  let remoteUrl = 'shipments/get-filter-info'

  return axios.get(remoteUrl, {params: params})
}

export const sendCarrier = (id, params) => {
  var remoteUrl = 'shipments/' + id + '/send-carrier'
  return axios.get(remoteUrl, {params: params})
}

export const login = () => {
  return axios({
    method: 'post',
    url: '/login',
    params: {
      username: 'nguyentranhoan13@gmail.com',
      password: '111111'
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json'
    }
  })
}

export const updateStatus = (id, data) => {
  return axios.post('shipments/' + id + '/update-status', data)
}

export const hardUpdateShipment = (id, shipment, params) => {
  var remoteUrl = 'shipments/' + id + '/hard-update'
  return axios.put(remoteUrl, shipment, { params: params })
}


// WEBPACK FOOTER //
// ./src/api/shipments.js